<script>
	import { cheatsheets } from '../stores/cheatsheets.js';
	let newSheet = {title: '', tags: '', body: ''}
	let backout = false;

	function doubleCheck() {
		backout = true;
	}

	function abortDiscard() {
		backout = false;
	}
</script>

{#if !backout}
	<a href="#/">
		<button on:click={cheatsheets.create(newSheet)} class="safe" id="save-btn">Save</button>
	</a>
	<button on:click={doubleCheck} class="danger" id="cancel-btn">Discard</button>
{:else if backout}
	<p id="discard-help">Discard this draft and return Home?</p>
	<a href="#/">
		<button class="danger">Yes, delete this</button>\
	</a>
	<button on:click={abortDiscard} class="safe">No, continue working</button>
{/if}

<div class="new-cheatsheet-container">
	<input id="new-title" bind:value={newSheet.title} placeholder="Title of Cheatsheet">
	<input id="new-tags" bind:value={newSheet.tags} placeholder="tag1,tag2,tag3">
	<textarea id="new-body" rows="30" bind:value={newSheet.body} placeholder="New Cheatsheet"></textarea>
</div>

<style>
	input {
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 80%;
	}

	textarea {
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 80%;
		resize: vertical;
	}

	.safe {
		background-color: #90fa39;
	}

	.danger {
		background-color: #fc8d8d;
	}

	.safe:hover {
		background: transparent;
	}
	
	.danger:hover{
		background: transparent;
	}

	#save-btn {
		margin-left: 10%;
		background: transparent;
	}

	#save-btn:hover {
		background-color: #90fa39;
	}
	
	#cancel-btn {
		background: transparent;
		border-color:lightcoral;
	}

	#cancel-btn:hover {
		background-color: #fc8d8d;
	}

	#discard-help {
		margin-left: 10%;
		display: inline;
	}
</style>
